import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#como-funciona", label: "Processo" },
  { href: "#vantagens", label: "Vantagens" },
  { href: "#faq", label: "FAQ" },
  { href: "#credenciais", label: "Credenciais" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all ${scrolled ? "backdrop-blur-xl bg-background/70 border-b border-border" : "bg-transparent"}`}>
      <div className="container flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="text-foreground font-display text-xl font-semibold tracking-tight">Juliano Wagner</span>
          <span className="hidden md:inline text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Patrimônio</span>
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {links.map(l => (
            <a key={l.href} href={l.href} className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid={`nav-link-${l.label.toLowerCase()}`}>{l.label}</a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <a href="#contato" className="inline-flex items-center text-sm px-5 py-2.5 rounded-full text-primary-foreground font-medium shadow-gold" style={{ background: "var(--gold-gradient)" }} data-testid="nav-cta">
            Receber meu diagnóstico →
          </a>
        </div>
        <button className="md:hidden text-foreground p-3 -mr-3" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label={open ? "Fechar menu" : "Abrir menu"} aria-expanded={open}>
          {open ? <X size={22}/> : <Menu size={22}/>}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="md:hidden overflow-hidden border-t border-border bg-background/95">
            <div className="container py-4 flex flex-col gap-4">
              {links.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-muted-foreground py-2">{l.label}</a>)}
              <a href="#contato" onClick={() => setOpen(false)} className="text-primary font-medium py-2">Receber meu diagnóstico →</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
